import { useState } from 'react'
import { Dropdown, Form, InputGroup } from 'react-angle-dashboard-components'

import {
  Control,
  Controller,
  Path,
  UseFormRegister,
  UseFormTrigger
} from 'react-hook-form'

import './CustomPlanFormModal.css'
import { ICustomPlanForm } from './CustomPlanFormModal'

const COPAYMENT = 'copayment'
const COINSURANCE = 'coinsurance'

const InputWithTypeSelector = <T extends ICustomPlanForm>({
  register,
  control,
  fieldKey,
  isInvalid,
  trigger
}: {
  register: UseFormRegister<T>
  control: Control<T>
  fieldKey: Path<T>
  isInvalid: boolean
  trigger: UseFormTrigger<T>
}) => {
  const valueKey = `${fieldKey}.value` as Path<T>
  const typeKey = `${fieldKey}.type` as Path<T>

  const [isDropdownOpen, setIsDropdownOpen] = useState(false)

  return (
    <InputGroup>
      <Form.Control {...register(valueKey)} isInvalid={isInvalid} />
      <InputGroup.Append
        style={{
          zIndex: isDropdownOpen ? 10 : undefined
        }}
      >
        <InputGroup.Text>
          <Controller
            name={typeKey}
            control={control}
            render={({ field: { onChange, value } }) => {
              const dropdownDisplay = value === COPAYMENT ? '$' : '%'

              return (
                <Dropdown
                  onSelect={(val) => {
                    onChange(val)
                    trigger(fieldKey)
                  }}
                  onToggle={(isOpen) => setIsDropdownOpen(isOpen)}
                  style={{
                    cursor: 'pointer',
                    userSelect: 'none'
                  }}
                >
                  <Dropdown.Toggle
                    as="div"
                    style={{
                      marginRight: -20
                    }}
                  >
                    {dropdownDisplay}
                    <span
                      style={{
                        marginLeft: 5
                      }}
                    >
                      &#x25BC;
                    </span>
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item eventKey={COPAYMENT}>
                      Copayment ($)
                    </Dropdown.Item>
                    <Dropdown.Item eventKey={COINSURANCE}>
                      Coinsurance (%)
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              )
            }}
          />
        </InputGroup.Text>
      </InputGroup.Append>
    </InputGroup>
  )
}

export default InputWithTypeSelector
